import {
    getListingTypes,
    deleteListingType,
    createListingType,
    updateListingType
} from '../../../services/ListingTypeService';
import {
    CONFIRMED_GET_LISTING_TYPES
} from './ListingTypeTypes';

export function getListingTypesAction(currentPage, pageSize, searchTerm, filterQuery) {
    return (dispatch, getState) => {
        dispatch({ type: 'SET_LISTING_TYPES_LOADING', payload: true });
        getListingTypes(currentPage, pageSize, searchTerm, filterQuery).then((response) => {
            dispatch(confirmedGetListingTypesAction(response.data.data));
        }).finally(() => {
            dispatch({ type: 'SET_LISTING_TYPES_LOADING', payload: false });
        });
    };
}

export function confirmedGetListingTypesAction(data) {
    return {
        type: CONFIRMED_GET_LISTING_TYPES,
        payload: data,
    };
}

export function deleteListingTypeAction(id, history) {
    return (dispatch, getState) => {
        return deleteListingType(id).then((response) => {
            return response;
        });
    };
}

export function createListingTypeAction(data) {
    return () => {
        return createListingType(data).then((response) => {
            return response;
        });
    };
}

export function updateListingTypeAction(id, data) {
    return () => {
        return updateListingType(id, data).then((response) => {
            return response;
        });
    };
}

